import type { RoomStorage, InternalRoomState } from '@merels/room/infrastructure.types'

/**
 * Browser-compatible in-memory storage adapter
 * Replaces Durable Object storage for local mode
 */
export class BrowserStorage implements RoomStorage {
  private state: InternalRoomState

  constructor(initialState?: InternalRoomState) {
    this.state = initialState || {
      activeGame: null,
      mates: [],
      gameSetup: null,
      createdAt: new Date().toISOString()
    }
  }

  getState(): InternalRoomState {
    return this.state
  }

  setState(state: InternalRoomState): void {
    this.state = state
  }
}
